import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JwtService } from './services';

import { AuthGuard } from './guards';
import { HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthenticationService } from './services/authentication.service';
import { AuthenticationInterceptor } from '../shared/interceptors/authentication.interceptor';
import { SessionStateService } from './services/session-state.service';
import { ApiService } from './services/api.service';
import { HandleErrorService } from './services/handle-error.service';

@NgModule({
  imports: [
    CommonModule
  ],
  providers: [
    HttpClient,
    JwtService,
    AuthGuard,
    AuthenticationService,
    SessionStateService,
    ApiService,
    HandleErrorService,
    { provide: HTTP_INTERCEPTORS, useClass: AuthenticationInterceptor, multi: true }
  ]
})
export class CoreModule { }



// WEBPACK FOOTER //
// ./src/app/core/core.module.ts